export default __webpack_public_path__ + "static/media/online_reserve.20095122.svg";